import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "nameInput"]

  connect() {
    // Initialize controller
  }

  // Save the current view with the given name
  save(event) {
    event.preventDefault()

    if (!this.nameInputTarget.value) {
      alert("Please enter a name for this view")
      return
    }

    this.formTarget.submit()
  }
}
